import React from 'react';

const PrepressTab = ({ jobData }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h2 className="text-xl font-bold text-gray-800 mb-4">Gestor de Prepress</h2>
      <div className="flex items-center justify-center h-48 bg-gray-50 rounded-lg">
        <p className="text-gray-500">Módulo de Prepress en desarrollo.</p>
      </div>
    </div>
  );
};

export default PrepressTab;
